var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowCircleWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 10.5782C0.5 5.01532 5.06044 0.5 10.6296 0.5C16.1989 0.5 20.7593 5.01532 20.7593 10.5782C20.7593 16.1411 16.1989 20.6564 10.6296 20.6564C5.06044 20.6564 0.5 16.1411 0.5 10.5782Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5614 5.76953L8.21289 10.3374L12.5614 14.9053",
    stroke: "white"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjIiIGhlaWdodD0iMjIiIHZpZXdCb3g9IjAgMCAyMiAyMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik0wLjUgMTAuNTc4MkMwLjUgNS4wMTUzMiA1LjA2MDQ0IDAuNSAxMC42Mjk2IDAuNUMxNi4xOTg5IDAuNSAyMC43NTkzIDUuMDE1MzIgMjAuNzU5MyAxMC41NzgyQzIwLjc1OTMgMTYuMTQxMSAxNi4xOTg5IDIwLjY1NjQgMTAuNjI5NiAyMC42NTY0QzUuMDYwNDQgMjAuNjU2NCAwLjUgMTYuMTQxMSAwLjUgMTAuNTc4MloiIHN0cm9rZT0id2hpdGUiLz4KICAgIDxwYXRoIGQ9Ik0xMi41NjE0IDUuNzY5NTNMOC4yMTI4OSAxMC4zMzc0TDEyLjU2MTQgMTQuOTA1MyIgc3Ryb2tlPSJ3aGl0ZSIvPgo8L3N2Zz4K";
export { SvgArrowCircleWhite as ReactComponent };